<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>店铺管理</el-breadcrumb-item>
			<el-breadcrumb-item>独立大厅申请记录</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div style="margin-left: 10px;">状态：</div>
				<el-select size="mini" v-model="search.status" placeholder="状态" style="width: 120px;">
					<el-option key="all" label="全部" :value="-1"></el-option>
					<el-option key="0" label="待处理" :value="0"></el-option>
					<el-option key="1" label="已同意" :value="1"></el-option>
					<el-option key="2" label="已拒绝" :value="2"></el-option>
				</el-select>
				<div>&nbsp;&nbsp;搜索：</div>
				<el-input size="mini" placeholder="SID / 账号 / 店铺名" v-model="search.keyword" style="margin-right: 10px; width:200px;"></el-input>
				<el-button size="mini" type="primary" @click="getData()">搜索</el-button>
				<el-button size="mini" type="warning" @click="reset()">重置</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="id" label="序号" align="center" width="80"></el-table-column>
				
				<el-table-column prop="shopInfo" label="店铺名" align="center" width="180">
					<template slot-scope="scope">
						{{scope.row.shop_name}}
					</template>
				</el-table-column>
				<el-table-column prop="sid" label="店主账号(SID)" align="center" width="220">
					<template slot-scope="scope">
						{{scope.row.username}}（{{scope.row.sid}}）
					</template>
				</el-table-column>
				<el-table-column prop="types" label="类型" align="center" width="180">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.types == 0" size="mini" type="info">已关闭</el-tag>
						<el-tag v-if="scope.row.types == 1" size="mini" type="primary">独立跟单</el-tag>
						<el-tag v-if="scope.row.types == 2" size="mini" type="danger">混合跟单</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="totalAmount" label="总流水" align="center" width="180">
					<template slot-scope="scope">
						{{scope.row.totalAmount}} 元
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" align="center" width="200">
					<template slot-scope="scope">
						<el-button type="info" v-if="scope.row.status==0" size="mini">待处理</el-button>
						<el-button type="success" v-if="scope.row.status==1" size="mini">已同意</el-button>
						<el-button type="danger" v-if="scope.row.status==2" size="mini">已拒绝</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="addTime" label="申请时间" align="center" width="220">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.addTime)}}
					</template>
				</el-table-column>
				<el-table-column prop="actionTime" label="操作时间" align="center" width="220">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.actionTime)}}
					</template>
				</el-table-column>
				
				<el-table-column prop="status" label="操作" fixed="right" align="center" width="200">
					<template slot-scope="scope">
						<el-button type="primary" @click="ActionApply(scope)" size="mini">操作</el-button>
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		<el-dialog title="操作" :visible.sync="actinShow" v-if="actinShow" width="800px" :before-close="handleClose">
			<actionApply :Info="actionInfo"></actionApply>
		</el-dialog>
	</div> 
</template>

<script>
	import actionApply from './actionApply.vue';
	
	export default {
		components:{
			actionApply
		},
		computed:{
		},
		data(){
			return {
				search:{
					keyword:'',
					status:-1,
				},
				actinShow:false,
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:10,
				actionInfo:{}
			}
		},
		created() {
			this.getData();
		},
		methods:{
			ActionApply(scope){
				this.actinShow = true;
				this.actionInfo = scope.row;
			},
			handleClose(){
				this.actinShow = false;
			},
			reset(){
				this.search = {
					keyword:'',
					status:-1,
				}
				this.getData();
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Virtuals/getApplyRecordList", {page:this.currentPage, limit:this.limit, ...this.search}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			},
			formatTimestamp(ts) {
				if(ts  == 0){
					return '';
				}
				// 如果是 10 位（秒），需要乘 1000 变成毫秒
				if (ts.toString().length === 10) {
					ts *= 1000
				}
				const date = new Date(ts)
			
				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')
			
				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
			
				return `${Y}-${M}-${D} ${h}:${m}:${s}`
			}
		}
	}
</script>

